<template>
    <svg fill="#ffffff" :width="size" :height="size" viewBox="0 0 16 16" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path d="M214.78,478l-20.67-21.57L403.27,256,194.11,55.57,214.78,34,446.46,256ZM317.89,256,86.22,34,65.54,55.57,274.7,256,65.54,456.43,86.22,478Z"></path>
    </g>
    </svg>
</template>

<script>
  export default {
    name: 'IconNextItem',
    props: {
       color: {
        type: String,
        default: "#F3F3F3",
       },
       size: {
        type: String,
        default: "1rem",
       },
    }
  }
</script>